import { useCheckout } from "./useCheckout"

export function SelectSeatsCheckoutStep() {
  const checkout = useCheckout()
  return <div>Select seats</div>
}
